/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_DetailsInputs */

const en_mk_loop_details = /** @type {(inputs: Mk_Loop_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the technical workflow, modes, and checks`)
};

const id_mk_loop_details = /** @type {(inputs: Mk_Loop_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat alur teknis, mode, dan pemeriksaan agent`)
};

/**
* | output |
* | --- |
* | "Explore the technical workflow, modes, and checks" |
*
* @param {Mk_Loop_DetailsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_details = /** @type {((inputs?: Mk_Loop_DetailsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_DetailsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_details(inputs)
	return en_mk_loop_details(inputs)
});